import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { MarkdownPipe } from '@common/pipe/markdown.pipe';
import { SafeHtmlPipe } from '@common/pipe/safe-html.pipe';
import { GlobalNotification } from '@common/types';

@Component({
  selector: 'app-global-notification',
  imports: [CommonModule, SafeHtmlPipe, MarkdownPipe],
  templateUrl: './global-notification.component.html',
  styleUrl: './global-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideAndFade', [
      // Enter animation
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100px) scale(0.8)',
          maxHeight: '0px',
          marginBottom: '0px',
          overflow: 'hidden',
        }),
        animate(
          '500ms cubic-bezier(0.68, -0.55, 0.27, 1.55)',
          style({
            opacity: 1,
            transform: 'translateX(0) scale(1)',
            maxHeight: '200px', // Reasonable max height
            marginBottom: '1rem',
          }),
        ),
      ]),
      // Leave animation
      transition(':leave', [
        style({
          opacity: 1,
          maxHeight: '200px',
          marginBottom: '1rem',
          overflow: 'hidden',
        }),
        animate(
          '400ms cubic-bezier(0.45, 0, 0.55, 1)',
          style({
            opacity: 0,
            maxHeight: '0px',
            marginBottom: '0px',
            transform: 'translateX(100px) scale(0.8)',
          }),
        ),
      ]),
    ]),
  ],
})
export class GlobalNotificationComponent {
  @Input() notification!: GlobalNotification;
  @Output() closed = new EventEmitter<void>();

  public iconMap: { [key: string]: string } = {
    success:
      // eslint-disable-next-line max-len
      '<svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>',
    error:
      // eslint-disable-next-line max-len
      '<svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" /></svg>',
    warning:
      // eslint-disable-next-line max-len
      '<svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" /></svg>',
    info:
      // eslint-disable-next-line max-len
      '<svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>',
  };

  constructor() {}

  close(): void {
    this.closed.emit();
  }
}
